import React, { Component } from "react";

import { CButton } from "@coreui/react";
import ReactAvatarEditor from "react-avatar-editor";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import "./forms.css";
import { updateUser } from "../../actions/baseActions";
import { profileUpdate, profileGet } from "../../actions/profileActions";
import profileEmpty from "../../assets/imgs/profileEmpty.jpg";
import URL from "../../config/api";
import AvatarsModal from "../AvatarsModal";

class Avatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      resource: "",
      allowZoomOut: false,
      position: { x: 0.5, y: 0.5 },
      scale: 1,
      rotate: 0,
      borderRadius: 50,
      // preview: null,
      width: 146,
      height: 146,
      // rangeVal: "",
      percent: 0,
      max: 2,
      show: true,
      render: false,
      modal: false
    };
    this.handleNewImage = this.handleNewImage.bind(this);
    this.cancel = this.cancel.bind(this);
    this.done = this.done.bind(this);
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    this.setState(
      {
        avatar: this.props.photo,
        user: this.props.user,
        show: false
      },
      () => {
        if (
          this.state.avatar !== null &&
          this.state.avatar !== "" &&
          this.state.avatar !== undefined
        )
          this.setState({
            render: true
          });
      }
    );
  }

  handleNewImage = dropped => {
    this.setState({ resource: dropped[0] });
  };

  handleScale = e => {
    const scale = parseFloat(e.target.value);
    this.setState({ scale });

    let val = e.target.value;
    let { max } = this.state;

    // eslint-disable-next-line react/no-unused-state
    this.setState(() => ({ rangeVal: val }));

    let newVal =
      ((max / 100) * parseInt((val - parseFloat(1)) * 100) * 100) / 2;
    this.setState(() => ({ percent: newVal }));
  };

  handlePositionChange = position => {
    this.setState({ position });
  };

  done() {
    if (this.editor) {
      const canvas = this.editor.getImage().toDataURL();
      this.setState(
        () => ({
          show: true,
          render: true,
          resource: ""
        }),
        () => {
          let { user } = this.state.user;
          user.token = this.state.user.token;
          user.photo = canvas;
          this.props.profileUpdate(user, null, () => {
            this.props.updateUser(user => {
              this.setState({ avatar: user.photo, show: false });
            });
          });
        }
      );
    }
  }

  handleAvatar(url) {
    this.setState(
      () => ({
        show: true,
        render: true,
        resource: "",
        avatar: url,
        modal: false
      }),
      () => {
        let { user } = this.state.user;
        user.token = this.state.user.token;
        user.photo = url;
        this.props.profileUpdate(user, null, () => {
          this.props.updateUser(user => {
            this.setState({ avatar: user.photo, show: false });
          });
        });
      }
    );
  }

  cancel() {
    this.setState(
      () => ({
        resource: "",
        allowZoomOut: false,
        position: { x: 0.5, y: 0.5 },
        scale: 1,
        rotate: 0,
        borderRadius: 50,
        // preview: null,
        width: 146,
        height: 146,
        // rangeVal: "",
        percent: 0,
        max: 2
      }),
      () => {}
    );
  }

  clear() {
    this.setState(
      () => ({
        show: true,
        render: true,
        resource: "",
        avatar: null
      }),
      () => {
        let { user } = this.state.user;
        user.token = this.state.user.token;
        user.photo = null;
        this.props.profileUpdate(user, null, () => {
          this.props.updateUser(user => {
            this.setState({ avatar: user.photo, show: false });
          });
        });
      }
    );
  }

  setEditorRef = editor => (this.editor = editor);

  render() {
    let percent = `${this.state.percent}%`;
    return (
      <React.Fragment>
        <div id="avatarArea">
          <div className="tlc">
            {!this.state.show ? (
              <ReactAvatarEditor
                ref={this.setEditorRef}
                scale={parseFloat(this.state.scale)}
                width={this.state.width}
                height={this.state.height}
                position={this.state.position}
                onPositionChange={this.handlePositionChange}
                rotate={parseFloat(this.state.rotate)}
                borderRadius={
                  this.state.width / (100 / this.state.borderRadius)
                }
                image={this.state.resource}
                className={
                  this.state.resource !== ""
                    ? "editor-canvas"
                    : "editor-canvas disabledCanvas"
                }
              />
            ) : (
              ""
            )}
          </div>
          <Dropzone onDrop={this.handleNewImage} noClick noKeyboard>
            {({ getRootProps, getInputProps }) => (
              <section
                className={this.state.resource !== "" ? "disabledCanvas" : ""}
              >
                {(!this.state.show &&
                  this.props.photo !== null &&
                  this.props.photo !== undefined &&
                  this.props.photo !== "") ||
                this.state.render ? (
                  <React.Fragment>
                    <img
                      className="imgAvatar avatarPos"
                      src={
                        this.state.avatar
                          ? URL.img + this.state.avatar
                          : profileEmpty
                      }
                      alt="profile"
                    />
                    <img
                      src={profileEmpty}
                      alt="profile defaut"
                      className="emptyProfile avatarPos haveImg"
                    />
                  </React.Fragment>
                ) : (
                  <img
                    src={profileEmpty}
                    alt="profile defaut"
                    className="emptyProfile avatarPos"
                  />
                )}
                <div {...getRootProps()} className="fileArea">
                  <input {...getInputProps()} ref={this.inputRef} />
                  {/* <img src={cloud} alt="" className="icon"/> */}
                  <div className="textAvatarWarper">
                    <p className="textAvatar">Arraste sua imagem para cá</p>
                  </div>
                </div>
              </section>
            )}
          </Dropzone>
          {this.state.resource !== "" && !this.state.show ? (
            <div className="cropArea">
              <label className="font-weight-bold">Zoom</label>
              <div className="block">
                <input
                  id="rangeCrop"
                  name="scale"
                  type="range"
                  onChange={this.handleScale}
                  min={this.state.allowZoomOut ? "0.1" : "1"}
                  max="2"
                  step="0.01"
                  defaultValue="1"
                />
                <div id="scalesCrop">
                  <div className="fill" style={{ width: percent }}></div>
                </div>
                <div className="btnArea">
                  <button
                    onClick={this.done}
                    className="btn btn-primary mr-auto"
                  >
                    Salvar
                  </button>
                  <button onClick={this.cancel} className="btn btn-secondary">
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="avatarActions w-100 d-flex justify-content-center mt-3 mb-4">
          {this.props.general.active_roles.role_id === 7 && (
            <CButton
              color="light"
              className="d-flex align-items-center mr-2 mb-2"
              onClick={() => this.setState({ modal: true })}
            >
              <i className="fa fa-user-circle mr-2" />
              Escolher avatar
            </CButton>
          )}
          <CButton
            color="light"
            className="d-flex align-items-center mr-2 mb-2"
            onClick={() => this.inputRef.current?.click()}
          >
            <i className="fa fa-upload mr-2" />
            Fazer upload
          </CButton>
          <CButton
            color="light"
            className="d-flex align-items-center mb-2"
            onClick={() => this.clear()}
          >
            <i className="fa fa-trash mr-2" />
            Limpar foto
          </CButton>
        </div>
        <AvatarsModal
          show={this.state.modal}
          onClose={() => this.setState({ modal: false })}
          onAvatar={url => this.handleAvatar(url)}
          url={this.props.photo}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = state => ({ user: state.user, general: state.general });

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      profileUpdate,
      profileGet,
      updateUser
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Avatar);
